import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=4aaa1774"
import script from "./IconBack.vue?vue&type=script&lang=js"
export * from "./IconBack.vue?vue&type=script&lang=js"
import style0 from "./IconBack.vue?vue&type=style&index=0&id=4aaa1774&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports